import { AuditEditorFunction } from "./auditEditorFunction";

export class AuditFormFlowControl {
  constructor($form, $vm) {
    this.$form = $form;
    this.$vm = $vm;
    this.$allControls = {};
    this.auditFormFlowLocateErrorControl = new AuditFormFlowLocateErrorControl(
      this
    );
    this.init();
  }
  init() {
    this?.unWatchAllControls?.();
    this.unWatchAllControls = this.$form.$watch(
      () => {
        return Object.keys(this.$form.$controls).join();
      },
      () => {
        let $allControls = {};
        for (const key in this.$form.$controls) {
          let control = this.$form.$controls[key];
          let hash;
          if (new RegExp(`^${control.designId}\-`).test(key)) {
            hash = key.split("-").pop();
          }
          let newKey = control.designId;
          if (control.metadata_fullcode) {
            newKey = control.metadata_fullcode;
          }
          if (hash) {
            newKey += "-" + hash;
          }
          $allControls[newKey] = control;
        }
        this.$allControls = $allControls;
      },
      {
        immediate: true,
      }
    );
  }
  unIinit() {
    if (this?.$vm?.$auditUnWacths) {
      for (let key in this.$vm.$auditUnWacths) {
        this.$vm.$auditUnWacths[key]?.();
      }
    }
    this?.unWatchAllControls?.();
    this?.unAuditFormFlowAll?.();
  }
  useAuditFormFlow(flowFormula, opt = { openRealTimeCompute: true }) {
    let funcControl = new AuditFormFlowFuncControl(
      this.$form,
      this.$vm,
      flowFormula,
      this,
      opt
    );
    if (!this.AuditFormFlowFuncControlMap) {
      this.AuditFormFlowFuncControlMap = {};
      this.AuditFormFlowFuncControlList = [];
    }
    if (!this.AuditFormFlowFuncControlMap[flowFormula.id]) {
      this.AuditFormFlowFuncControlMap[flowFormula.id] = funcControl;
      this.AuditFormFlowFuncControlList.push(funcControl);
      funcControl.initWatch();
    }
  }
  unAuditFormFlow(id) {
    let funcControl = this.AuditFormFlowFuncControlMap[id];
    if (funcControl) {
      let index = this.AuditFormFlowFuncControlList.findIndex(
        (it) => it.id == id
      );
      if (index >= 0) {
        this.AuditFormFlowFuncControlList.splice(index, 1);
      }
      funcControl.unInitWatch();
    }
  }
  runAuditFormFlowAllWatchCall() {
    for (
      let index = 0;
      index < this.AuditFormFlowFuncControlList.length;
      index++
    ) {
      const it = this.AuditFormFlowFuncControlList[index];
      it.watchCall();
    }
  }
  unAuditFormFlowAll() {
    for (const key in this.AuditFormFlowFuncControlMap) {
      this.unAuditFormFlow(key);
      delete this.AuditFormFlowFuncControlMap[key];
    }
  }
  useAuditFormFlowValidate(flowFormula) {
    let validateControl = new AuditFormFlowValidateControl(
      this.$form,
      this.$vm,
      flowFormula,
      this
    );
    if (!this.auditFormFlowValidateControlMap) {
      this.auditFormFlowValidateControlMap = {};
    }
    this.auditFormFlowValidateControlMap[flowFormula.id] = validateControl;
    validateControl.init();
  }
  runValidateAll() {
    let errList = [];
    for (const key in this.auditFormFlowValidateControlMap) {
      errList = errList.concat(
        this.auditFormFlowValidateControlMap[key].validate()
      );
    }
    return errList;
  }
}

export class AuditFormFlowLocateErrorControl {
  constructor(auditFormFlowControl, opts = {}) {
    this.auditFormFlowControl = auditFormFlowControl;
    this.currentVm = null;
    this.auditList = [];
    this.currentAuditIndex = 0;
    this.currentFieldIndex = 0;
    this.highlightClass = "ds-form-item-formula-error-highlight";
    this.locateFieldBefore = opts?.locateFieldBefore || ((a, next) => next());
  }
  get $form() {
    return this.auditFormFlowControl?.$form;
  }
  get $vm() {
    return this.auditFormFlowControl?.$vm;
  }
  get $allControls() {
    return this.auditFormFlowControl?.$allControls;
  }
  get auditErrorId() {
    return this.auditInfo?.auditErrorId;
  }
  get errorLocationInfoVoList() {
    return (this.auditInfo?.errorLocationInfoVoList || []).filter(
      (it) => !it.getItemsAttachText
    );
  }
  get auditInfo() {
    return this.auditList[this.currentAuditIndex];
  }
  get fieldInfo() {
    return this.errorLocationInfoVoList[this.currentFieldIndex];
  }
  get errorToolVm() {
    if (!this.$errorToolVm) {
      const locateVm = this;
      this.$errorToolVm = new Vue({
        data() {
          return {};
        },
        methods: {
          prevError() {
            locateVm.nextError();
          },
          prevAudit() {
            locateVm.prevAudit();
          },
          nextAudit() {
            locateVm.nextAudit();
          },
          openEditRemark() {
            let auditInfo = locateVm.auditInfo;
            dsf.layer.openDialog({
              title: "填写澄清说明",
              type: "dialog",
              content: {
                props: {
                  remark: {
                    default: "",
                  },
                  errHint: {
                    default: "",
                  },
                },
                data() {
                  return {
                    inputVal: this.remark,
                  };
                },
                methods: {
                  input(e) {
                    this.inputVal = e.target.value;
                  },
                  yes() {
                    if (this.inputVal.length < 6) {
                      dsf.layer.message("澄清说明必须大于6个字符", false);
                      return false;
                    }
                    return this.inputVal;
                  },
                },
                render() {
                  return (
                    <div class="remark-edit-panel mobile">
                      <div class="remark-edit-panel-row">
                        <div class="remark-edit-panel-row-label">
                          提示信息：
                        </div>
                        <div class="remark-edit-panel-row-value">
                          {this.errHint}
                        </div>
                      </div>
                      <div class="remark-edit-panel-row">
                        <div class="remark-edit-panel-row-label">
                          澄清说明：
                        </div>
                        <div class="remark-edit-panel-row-value">
                          <textarea
                            value={this.inputVal}
                            oninput={this.input}
                            rows="4"
                            placeholder="请填写说明"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              params: {
                remark: auditInfo.errInfo,
                errHint: auditInfo.errHint,
              },
              btns: [
                {
                  text: "确定",
                  handler: (vm) => {
                    let res = vm.yes();
                    if (res === false) return false;
                    this.$set(auditInfo, "errInfo", res || "");
                  },
                },
                {
                  text: "取消",
                },
              ],
            });
          },
        },
        render() {
          if (!locateVm?.auditInfo) return <div></div>;
          let btns = [];
          if (locateVm.currentAuditIndex > 0) {
            btns.push(
              <div class="dsf-fifehc-btn" prevAudit onClick={this.prevAudit}>
                上一条审核
              </div>
            );
          }
          if (locateVm.auditInfo.isShowText) {
            btns.push(
              <div
                class="dsf-fifehc-btn"
                eidtRemark
                onClick={this.openEditRemark}
              >
                填写澄清说明
              </div>
            );
          }
          if (locateVm.errorLocationInfoVoList?.length > 1) {
            btns.push(
              <div class="dsf-fifehc-btn" prevError onClick={this.prevError}>
                关联指标
              </div>
            );
          }
          if (locateVm.currentAuditIndex < locateVm.auditList.length - 1) {
            btns.push(
              <div class="dsf-fifehc-btn" nextAudit onClick={this.nextAudit}>
                下一条审核
              </div>
            );
          }
          return (
            <div class="ds-form-item-formula-error-highlight-ctrl">{btns}</div>
          );
        },
      });
      this.$errorToolVm.$mount($("<div></div>")[0]);
    }
    return this.$errorToolVm;
  }
  init({ auditList }) {
    this.unIinit();
    this.auditList = auditList || [];
  }
  unIinit() {
    this.auditList = [];
    this.destroy();
  }
  locateAudit(auditErrorId) {
    this.currentAuditIndex = this.auditList.findIndex(
      (error) => error.auditErrorId == auditErrorId
    );
    this.clearFromAuditAddError();
    this.renderHighlightCtrls();
    this.currentFieldIndex = -1;
    this.nextError();
  }
  clearFromAuditAddError() {
    const $errors = this.$form.$errors || {};
    const reserveErrors = [];
    for (const key in $errors) {
      $errors[key].forEach((item) => {
        if (item?.info?.isAuditAdd) {
          return;
        }
        reserveErrors.push(item);
      });
    }
    this.$form.clearErrors();
    this.$form.pushError(reserveErrors);
  }
  renderHighlightCtrls() {
    let formEL = this.$form.$el;
    let highlightClass = this.highlightClass;
    $(formEL).find(`.${highlightClass}`).removeClass(highlightClass);
    this.errorLocationInfoVoList.forEach((item) => {
      let fieldKey = this._getFieldFormName(item);
      this.$form.pushError({
        info: {
          isAuditAdd: true,
        },
        target: fieldKey,
        message: this.auditInfo.errHint,
      });
      setTimeout(() => {
        $(formEL)
          .find(`.ds-form-item[form-name="${fieldKey}"]`)
          .addClass(highlightClass);
      }, 200);
    });
  }
  _getFieldFormName(fieldInfo) {
    let fieldName = fieldInfo.fieldName;
    if (fieldInfo.getItemsAttachText) {
      fieldName = fieldName.replace(/\_attach$/, "");
    } else if (fieldInfo.itemsCtrl) {
      fieldName = fieldName.replace(/\_value$/, "");
    }
    let key = `${fieldInfo.tableName}.${fieldName}`;
    if (!fieldInfo.mainTable) {
      let hash;
      let subListData = this.$vm.$viewData[fieldInfo.tableName] || [];
      let rowId = fieldInfo.dataIdJson[`${fieldInfo.tableName}_id`];
      if (/^row_index_/.test(rowId)) {
        rowId = rowId.replace(/^row_index_/, "");
        hash = subListData[rowId].$hash;
      } else {
        hash = subListData.find((row) => row._id == rowId).$hash;
      }
      key += "-" + hash;
    }
    return key;
  }
  locateField() {
    this.locateFieldBefore(this, (state) => {
      if (state === false) return;
      let fieldInfo = this.fieldInfo;
      let fieldKey = this._getFieldFormName(fieldInfo);
      let fieldEl = $(this.$form.$el).find(
        `.ds-form-item[form-name="${fieldKey}"]`
      )[0];
      $(fieldEl).append(this.errorToolVm.$el);
      this.errorToolVm.$forceUpdate();
      this.$form.$scrollToError(this.$form.$errors[fieldKey], {
        behavior: "instant",
        block: "center",
        inline: "center",
      });
    });
  }
  nextError() {
    this.currentFieldIndex++;
    if (this.currentFieldIndex >= this.errorLocationInfoVoList.length) {
      this.currentFieldIndex = 0;
    }
    this.locateField();
  }
  nextAudit() {
    if (this.currentAuditIndex + 1 > this.auditList.length - 1) {
      return dsf.layer.message("不存在下一条审核信息", false);
    }
    this.currentAuditIndex++;
    this.locateAudit(this.auditInfo.auditErrorId);
  }
  prevAudit() {
    if (this.currentAuditIndex - 1 < 0) {
      return dsf.layer.message("不存在上一条审核信息", false);
    }
    this.currentAuditIndex--;
    this.locateAudit(this.auditInfo.auditErrorId);
  }
  destroy() {
    if (this.errorToolVm) {
      this.errorToolVm?.$destroy?.();
      $(this.errorToolVm.$el)?.remove?.();
      this.$errorToolVm = null;
    }
  }
}

class AuditFormFlowCommonControl {
  constructor($form, $vm, flowFormula, auditFormFlowControl, opt = {}) {
    this.$form = $form;
    this.$vm = $vm;
    this.flowFormula = flowFormula;
    this.auditFormFlowControl = auditFormFlowControl;
    this.openRealTimeCompute = opt.openRealTimeCompute ?? true;
  }
  get $allControls() {
    return this.auditFormFlowControl.$allControls || {};
  }
  buildWatchDataList() {
    let watchData = {};
    this.watchTableList.forEach((relationCtrl) => {
      let key = `${relationCtrl.tableName}.${relationCtrl.field}`;
      watchData[key] = this.$vm.$viewData?.[key];
    });
    let watchSubTableList = [];
    for (const key in this.watchSubTableMap) {
      let list = this.watchSubTableMap[key].filter(
        (item) => !item.isSumComputed
      );
      list.length && watchSubTableList.push([key, list]);
    }
    if (watchSubTableList.length) {
      let watchDataList = [];
      this.buildSubTableRows(watchSubTableList, watchData, watchDataList);
      return watchDataList;
    }
    return [watchData];
  }
  buildSubTableRows(watchSubTableList, watchData, watchDataList) {
    let [subTableName] = watchSubTableList.shift();

    this.$form.$viewData[subTableName]?.forEach((rowData) => {
      let rowWatchData = {
        [`${subTableName}.$hash`]: rowData.$hash,
        [`${subTableName}.$index`]: rowData.$index,
        [`${subTableName}.$order`]: rowData.$order,
        [`${subTableName}._id`]: rowData._id,
      };
      watchData = Object.assign({}, watchData, rowWatchData);
      if (watchSubTableList.length) {
        this.buildSubTableRows(watchSubTableList, watchData, watchDataList);
      } else {
        watchDataList.push(watchData);
      }
    });
  }
}
class AuditFormFlowValidateControl extends AuditFormFlowCommonControl {
  init() {
    this.buildWatchTableList();
  }
  buildWatchTableList() {
    let flowFormula = this.flowFormula;
    this.watchSubTableMap = {};
    this.watchTableList = [];
    for (const key in flowFormula.jsFieldMap) {
      let fieldMap = flowFormula.jsFieldMap[key];
      if (fieldMap.isSubTable) {
        if (!this.watchSubTableMap[fieldMap.subTableName]) {
          this.watchSubTableMap[fieldMap.subTableName] = [];
        }
        this.watchSubTableMap[fieldMap.subTableName].push(fieldMap);
      } else {
        if (!fieldMap.tableName) fieldMap.tableName = flowFormula.mainTableName;
        this.watchTableList.push(fieldMap);
      }
    }
  }
  getDynamicFunction(code) {
    let dynamicFunction = new Function("args", code);
    return dynamicFunction;
  }
  validate() {
    let watchDataList = this.buildWatchDataList();
    let errList = [];
    watchDataList.forEach((watchData) => {
      let dynamicFunction = this.getDynamicFunction(`
              with (args) {
                // console.log(args.$subExpressionId);
               return ${this.flowFormula.expression}
              }
            `);
      let argsData = {
        $subExpressionId: this.flowFormula.id,
        $viewData: this.$vm.$viewData,
        $watchData: watchData || {},
        $crossTableData: this.flowFormula.crossTableData,
        $serverRequestData: this.$vm._viewDataBak || {},
        $viewInitData: this.$vm?.$viewInitData || {},
        $formula_id: this.flowFormula.formula_id,
        $queryString: this.$form?.queryString || {},
      };
      let res = dynamicFunction(
        Object.assign(
          {},
          argsData,
          {
            $form: this.$form,
            $vm: this.$vm,
            $allControls: this.$allControls,
          },
          this.flowFormula.jsFieldMap,
          AuditEditorFunction.getAllFunMap()
        )
      );
      !res && errList.push(this.buildError({ argsData }));
    });
    return errList;
  }
  buildError({ argsData }) {
    let flowFormula = this.flowFormula;
    let errorObj = {
      auditErrorId: dsf.uuid(32),
      formulaId: argsData.$formula_id,
      ruleCode: flowFormula.rule_code,
      ruleId: flowFormula.rule_id || argsData.$formula_id,
      executeOrder: flowFormula.execute_order,
      errInfo: flowFormula.err_info,
      errHint: flowFormula.err_hint,
      clarifyWay: flowFormula.clarifyWay,
      clarifyValue: flowFormula.clarifyValue,
      verifyTypeText: flowFormula.verify_type_text,
      verifyTypeValue: flowFormula.verify_type_value,
      demotion: false,
      physicsTableName: flowFormula.mainTableName,
      errorLocationInfoVoList: [],
    };
    const jsFieldMap = flowFormula.jsFieldMap;
    let errorLocationInfoVoListMap = {};
    for (const key in jsFieldMap) {
      let field = jsFieldMap[key];
      let vo = {
        tableName: field.tableName,
        fieldName: field.field,
        mainTable: true,
        dataIdJson: {},
        subIdMap: null,
        statsMetaCode: null,
        errHint: flowFormula.err_hint,
        itemsCtrl: field.items_ctrl,
        getItemsAttachText: field.get_items_attach_text,
      };
      if (field.isSubTable) {
        vo.mainTable = false;
        vo.tableName = field.subTableName;
        let subRowId = argsData.$watchData[`${field.subTableName}._id`];
        let subRowIndex = argsData.$watchData[`${field.subTableName}.$index`];
        vo.dataIdJson[`${field.subTableName}_id`] =
          subRowId || `row_index_${subRowIndex}`;
      }
      if (!errorLocationInfoVoListMap[`${vo.tableName}.${vo.fieldName}`]) {
        errorLocationInfoVoListMap[
          `${vo.tableName}.${vo.fieldName}`
        ] = `${vo.tableName}.${vo.fieldName}`;
        errorObj.errorLocationInfoVoList.push(vo);
      }
    }
    return errorObj;
  }
}

class AuditFormFlowFuncControl extends AuditFormFlowCommonControl {
  constructor() {
    super(...arguments);
    this.FUNCTION_MAP = AuditFormFlowControl.FUNCTION_MAP;
  }
  initWatch() {
    let flowFormula = this.flowFormula;
    this.watchSubTableMap = {};
    this.watchTableList = [];
    for (const key in flowFormula.jsFieldMap) {
      let fieldMap = flowFormula.jsFieldMap[key];
      if (fieldMap.isSubTable) {
        if (!this.watchSubTableMap[fieldMap.subTableName]) {
          this.watchSubTableMap[fieldMap.subTableName] = [];
        }
        this.watchSubTableMap[fieldMap.subTableName].push(fieldMap);
      } else {
        if (!fieldMap.tableName) fieldMap.tableName = flowFormula.mainTableName;
        this.watchTableList.push(fieldMap);
      }
    }
    this.watchTable();
    this.watchSubTable();
  }
  unInitWatch() {
    this.unWatchTable();
    this.unWatchSubTableAll();
  }
  getDynamicFunction(code) {
    let dynamicFunction = new Function("globalArgs", code);
    return dynamicFunction;
  }
  watchTable() {
    this.unWatchTable();
    let immediate = true||this.watchTableList.some((field) => field.isGetValue);
    this.unWatchTableFn = this.$form.$watch(
      () => {
        let res = "";
        this.watchTableList.forEach((field) => {
          if (field.isGetValue) {
            let key = `${field.tableName}.${field.field}`;
            res += JSON.stringify(this.$vm.$viewData?.[key]);
          }
        });
        return res;
      },
      (watchData, oldVal) => {
        if (watchData != oldVal) {
          this.watchCall();
        }
      },
      {
        immediate,
      }
    );
  }
  unWatchTable() {
    this.unWatchTableFn && this.unWatchTableFn();
    this.unWatchTableFn = null;
  }
  watchSubTable() {
    this.unWatchSubTableAll();
    for (const key in this.watchSubTableMap) {
      this.unWatchSubTableMap[key] = {
        unWatchRows: [],
      };
      this.unWatchSubTableMap[key].mainUnWatch = this.$form.$watch(
        () => {
          return this.$form.$viewData[key];
        },
        (newVal, oldVal) => {
          let subTableImmediate = this.watchSubTableRowAll(key);
          if (subTableImmediate) {
            this.watchCall();
          }
        },
        {
          immediate: true,
        }
      );
    }
    this.$viewData;
  }
  watchSubTableRowAll(subTableName) {
    this.unWatchSubTableRowAll(subTableName);
    let subTableNameData = this.$form.$viewData[subTableName] || [];
    let subTableImmediate = false;
    subTableNameData.forEach((row) => {
      let immediate = this.watchSubTableMap[subTableName].some(
        (relationCtrl) => relationCtrl.isGetValue
      );
      if (immediate) {
        subTableImmediate = immediate;
        this.unWatchSubTableMap[subTableName].unWatchRows.push(
          this.$form.$watch(
            () => {
              let res = "";
              this.watchSubTableMap[subTableName].forEach((relationCtrl) => {
                if (relationCtrl.isGetValue) {
                  let key = `${subTableName}.${relationCtrl.field}`;
                  res += JSON.stringify(
                    this.$form.$viewData[subTableName][row.$index][key]
                  );
                }
              });
              return res;
            },
            (newVal, oldVal) => {
              if (newVal != oldVal) {
                this.watchCall();
              }
            },
            {
              immediate,
            }
          )
        );
      }
    });
    return subTableImmediate;
  }
  unWatchSubTableAll() {
    if (this.unWatchSubTableMap) {
      for (const key in this.unWatchSubTableMap) {
        this.unWatchSubTableMap[key]?.forEach?.((unWatch) => {
          unWatch?.();
        });
      }
    }
    this.unWatchSubTableMap = {};
  }
  unWatchSubTableRowAll(subTableName) {
    if (this.unWatchSubTableMap[subTableName]) {
      if (this.unWatchSubTableMap[subTableName]?.unWatchRows) {
        this.unWatchSubTableMap[subTableName]?.unWatchRows?.forEach?.(
          (unWatch) => {
            unWatch();
          }
        );
      }
      this.unWatchSubTableMap[subTableName].unWatchRows = [];
    } else {
      this.unWatchSubTableMap[subTableName] = {
        unWatchRows: [],
      };
    }
  }
  watchCall() {
    let flowFormula = this.flowFormula;
    let watchDataList = this.buildWatchDataList();
    watchDataList.forEach((watchData) => {
      let dynamicFunction = this.getDynamicFunction(`
              with (globalArgs) {
                // console.log(globalArgs.$subExpressionId);
                ${flowFormula.expression}
              }
            `);
      dynamicFunction(
        Object.assign(
          {
            $subExpressionId: this.flowFormula.id,
            $form: this.$form,
            $vm: this.$vm,
            $viewData: this.$vm.$viewData,
            $watchData: watchData || {},
            $allControls: this.$allControls,
            $crossTableData: flowFormula.crossTableData,
            $serverRequestData: this.$vm._viewDataBak || {},
            $viewInitData: this.$vm?.$viewInitData || {},
            $formula_id: this.flowFormula.formula_id,
            $queryString: this.$form?.queryString || {},
          },
          flowFormula.jsFieldMap,
          AuditEditorFunction.getAllFunMap()
        )
      );
    });
  }
}
